module.exports = __webpack_public_path__ + "static/media/nerito-marketing-background.490f3b0d.png";